import PhoneInput from 'react-phone-number-input'
import styled from 'styled-components'

export default styled(PhoneInput).attrs({
  className: 'form-control',
  defaultCountry: 'BR',
})`
  display: flex;

  ${props =>
    props.disabled
      ? `
          background-color: #f5f5f1;
          opacity: 1;
        `
      : ''}

  &:focus-within {
    color: #4e5154;
    background-color: #fff;
    border-color: #7367f0;
    outline: 0;
    box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15);
  }

  input {
    outline: none !important;
    border: none;
    background: inherit;
    width: inherit;
  }

  .PhoneInputCountry {
    border-right: 1px solid #d1d1d1;
    padding-right: 10px;
  }

  .PhoneInputCountrySelectArrow {
    display: none;
  }
`
